var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5858 12.9999L4.94373 19.642L6.35794 21.0562L13 14.4141L19.6422 21.0563L21.0564 19.6421L14.4142 12.9999L21.2072 6.20694L19.793 4.79272L13 11.5857L6.20718 4.79288L4.79297 6.20709L11.5858 12.9999Z"
  })));
}
export default SvgPlaceIconClose;